import {call, delay, put, select} from "typed-redux-saga";
import {Api, ApiError} from "modules/utils";
import {
	changeAvatar,
	changeAvatarButtonType,
	changeAvatarFailed,
	changeAvatarSuccess,
	changePassword,
	changePasswordFailed,
	changePasswordSuccess,
	hideModal,
	openModal,
	requestUserFailed,
	requestUserSuccess,
	showErrorModal,
	updateUser,
	updateUserFailed,
	updateUserSuccess,
} from "modules/actions";
import {ButtonType} from "modules/enums";
import {getUser} from "modules/selectors";

export const requestUserSaga = function* () {
	try {
		const response = yield* call(Api.User.get);
		yield* put(requestUserSuccess(response.success.user));
	} catch (err) {
		yield* put(requestUserFailed());
	}
};

export const updateUserSaga = function* ({payload}: ReturnType<typeof updateUser>) {
	try {
		const oldUser = yield* select(getUser);
		const oldUsername = oldUser?.username;

		const response = yield* call(Api.User.update, payload);

		if (oldUsername !== payload.username) {
			yield* call(Api.Fantasy.updateTeamName, {name: payload.username});
		}

		yield* put(updateUserSuccess(response.success.user));
		yield* put(openModal("successUpdateProfile"));
	} catch (err) {
		const {message} = err as ApiError;
		yield* put(updateUserFailed({form: message}));
	}
};

export const changePasswordSaga = function* ({payload}: ReturnType<typeof changePassword>) {
	try {
		const response = yield* call(Api.User.changePassword, payload);
		yield* put(changePasswordSuccess(response.success.user));
		yield* put(openModal("successChangePassword"));
	} catch (err) {
		const {message} = err as ApiError;
		yield* put(changePasswordFailed({form: message}));
	}
};

export const changeAvatarSaga = function* ({payload}: ReturnType<typeof changeAvatar>) {
	try {
		const response = yield* call(Api.User.changeAvatar, payload);
		yield* put(changeAvatarSuccess(response.success.user));
		yield* put(changeAvatarButtonType(ButtonType.Saved));
		yield* delay(1000); // 1s
		yield* put(changeAvatarButtonType(ButtonType.Enabled)); // return to default state
		yield* put(hideModal("changeAvatar"));
	} catch (err) {
		yield* put(changeAvatarFailed());
		yield* put(hideModal("changeAvatar"));
		const {message} = err as ApiError;
		yield* put(showErrorModal({message}));
	}
};
